namespace GeniuzPOS.InitialData {
    export interface PsCurrencyForm {
        CurrencyCode: Serenity.StringEditor;
        CurrencyName: Serenity.StringEditor;
        IsActive: Serenity.BooleanEditor;
    }

    export class PsCurrencyForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsCurrency';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsCurrencyForm.init)  {
                PsCurrencyForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;

                Q.initFormType(PsCurrencyForm, [
                    'CurrencyCode', w0,
                    'CurrencyName', w0,
                    'IsActive', w1
                ]);
            }
        }
    }
}
